import React from 'react';
import { func, bool } from 'prop-types';
import styled from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

const SwitchButton = styled.button`
  position: relative;
  background: ${({ theme, isOn }) => (isOn ? theme.toggleBackgroundOn : theme.background)};
  border: 2px solid ${({ theme }) => theme.toggleBorder};
  color: ${({ theme, isOn }) => (isOn ? theme.toggleTextOn : theme.text)};
  border-radius: 30px;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 0.6rem;
  &::before {
    content: "";
    position: absolute;
    left: ${({ isOn }) => (isOn ? "22px" : "2px")};
    top: 2px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: ${({ theme }) => theme.toggleCircle};
    transition: transform 0.2s ease-in;
  }
  &:active::before {
    transform: translateX(${({ isOn }) => (isOn ? "0px" : "20px")});
  }
`;

const Toggle = ({ isOn, toggleTheme }) => {
  return (
    <SwitchButton onClick={toggleTheme} isOn={isOn}>
      {isOn ? <FontAwesomeIcon icon={faSun} /> : <FontAwesomeIcon icon={faMoon} />}
      {!isOn ? "ON" : "OFF"}
    </SwitchButton>
  );
};

Toggle.propTypes = {
  toggleTheme: func.isRequired,
  isOn: bool.isRequired
};

export default Toggle;
